<template>
  <div class="steps-content">
    <el-form
      ref="form"
      :model="formData"
      :rules="secondStepRules"
      @submit.native.prevent
    >
      <el-row :gutter="24">
        <el-col :xs="24" :sm="12">
          <autocomplete-custom
            placeholder="Регион"
            :lib="autocompleteSettingsTwo.regionUnLoad"
            name="regionUnLoad"
            :edit="getText(0)"
            @selected="setRegionUnLoad"
          >
            Регион выгрузки
          </autocomplete-custom>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item :error="checkKladr">
            <autocomplete-custom
              placeholder="Населенный пункт"
              :lib="autocompleteSettingsTwo.kladrUnLoad"
              name="kladrUnLoad"
              :disabled="isRegionUnLoad"
              :relation="autocompleteSettingsTwo.kladrUnLoad.params.regionId"
              :edit="getText(1)"
              @selected="setUnLoadKladr"
            >
              Населенный пункт выгрузки
            </autocomplete-custom>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :xs="24" :sm="12">
          <el-form-item prop="distance">
            <p>Расстояние, км</p>
            <el-input-number
              v-model="formData.distance"
              controls-position="right"
              :min="0"
              placeholder="Укажите расстояние между местом погрузки и выгрузки"
            />
          </el-form-item>
        </el-col>
        <el-col class="cargo-block" :xs="24" :sm="12">
          <set-stevedore @changed="stevedoreChanged" />
          <el-form-item label="Короткое название" prop="cargo_receiver_name">
            <el-input
              v-model="formData.cargo_receiver_name"
              placeholder="Укажите короткое название"
            />
          </el-form-item>
          <el-form-item label="Юр. Название" prop="cargo_receiver_legal_name">
            <el-input
              v-model="formData.cargo_receiver_legal_name"
              placeholder="Укажите юр. название"
            />
          </el-form-item>
          <el-form-item label="Юр. Адрес" prop="cargo_receiver_address">
            <el-input
              v-model="formData.cargo_receiver_address"
              placeholder="Укажите юр. адрес"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="bottom_buttons">
      <el-button @click="setFormData(-1)">Назад</el-button>
      <el-button @click="setFormData(1)">Далее</el-button>
    </div>
  </div>
</template>

<script>
import { autocompleteSettingsTwo } from '@/datas/consts'
import { checkAutocomplite } from '@/helpers/functions'
import { secondStepRules } from '@/views/Home/Shipping/Steps/constants'
import AutocompleteCustom from '@/components/Forms/AutocompleteCustom'
import SetStevedore from '@/components/Stividors/SetStevedore'

export default {
  name: 'Two',
  components: { SetStevedore, AutocompleteCustom },
  props: {
    saved: {
      type: Object,
      default: () => undefined,
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      formData: {
        unload_point: '',
        unload_point_kladr_id: '',
        unload_coords_lat: '',
        unload_coords_lon: '',
        cargo_receiver_name: '',
        cargo_receiver_legal_name: '',
        cargo_receiver_address: '',
        distance: undefined,
      },
      unload_point_region: {},
      unload_kladr: '',
      autocompleteSettingsTwo,
      checkKladr: '',
      secondStepRules,
      updated: false,
    }
  },
  computed: {
    isRegionUnLoad() {
      return !this.autocompleteSettingsTwo.kladrUnLoad.params.regionId
    },
  },
  watch: {
    saved: {
      immediate: true,
      handler(newVal) {
        this.setAutocomplete(newVal)
      },
    },
  },
  methods: {
    setAutocomplete(val) {
      this.autocompleteSettingsTwo.kladrUnLoad.params.regionId = null
      this.formData = { ...this.formData, ...val }
      this.updated = false
    },
    getText(flag = 0) {
      const { unload_point, unload_point_kladr_id } = this.formData

      return checkAutocomplite(
        flag,
        unload_point,
        unload_point_kladr_id,
        this.updated,
      )
    },
    setRegionUnLoad(item) {
      this.autocompleteSettingsTwo.kladrUnLoad.params.regionId = item.id
      this.unload_point_region = item

      if (this.updated) {
        this.unload_kladr = ''
        this.formData.unload_point = ''
        this.formData.unload_point_kladr_id = ''
        this.formData.unload_coords_lat = ''
        this.formData.unload_coords_lon = ''
      }
    },
    setUnLoadKladr(item) {
      this.unload_kladr = item.id
      this.checkKladr = ''
      this.formData.unload_point_kladr_id = item.id
      this.formData.unload_point = item.name
        ? this.unload_point_region.name + ',' + item.name
        : ''
      this.formData.unload_coords_lat = item.coords_lat
      this.formData.unload_coords_lon = item.coords_lon

      if (!this.updated) {
        this.updated = true
      }
    },
    setFormData(step) {
      if (step === -1) {
        this.$emit('change_step', { data: this.formData, step })
      } else if (!this.formData.unload_point_kladr_id) {
        this.checkKladr = 'Укажите пункт отгрузки'
        this.$emit('invalid')
      } else {
        this.$refs['form'].validate(valid => {
          if (valid) {
            this.$emit('change_step', { data: this.formData, step })
          } else {
            this.$emit('invalid')
          }
        })
      }
    },
    stevedoreChanged(data) {
      const { name, legal_name, legal_address } = data

      this.formData.cargo_receiver_name = name
      this.formData.cargo_receiver_legal_name = legal_name
      this.formData.cargo_receiver_address = legal_address
    },
  },
}
</script>
